import { Content } from 'src/contexts/ContentContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import { useAlertWithSuppressionDialog } from './useAlertWithSuppressionDialog';
import { useEventConfirmationDialogSuppressionTimestamp } from './useEventConfirmationDialogSuppressionTimestamp';

export function useManualPriceDisableAutoPricingDialog(
  onOkay: () => void,
  viagogoVirtualId?: string | null
) {
  const { value, ...rest } = useAlertWithSuppressionDialog(
    'manualPriceDisableAutoPricingTimestamp',
    onOkay,
    undefined
  );

  const hasSellerEventAlertMutesFeature = useUserHasFeature(
    Feature.SellerEventAlertMutes
  );

  const eventLastTimeStamp = useEventConfirmationDialogSuppressionTimestamp(
    'manualPriceDisableAutoPricingTimestamp',
    viagogoVirtualId
  );

  const lastTimeStamp =
    hasSellerEventAlertMutesFeature && viagogoVirtualId
      ? eventLastTimeStamp
      : value?.manualPriceDisableAutoPricingTimestamp;

  return {
    ...rest,
    lastTimeStamp,
    bodyText: <Content id={ContentId.ManualPriceDisableAutoPricingWarning} />,
  };
}
